"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WifiOn = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var WifiOn = function WifiOn(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#wfo-clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.76172 12.7383C8.21484 11.3086 9.96094 10.5938 12 10.5938C14.0625 10.5938 15.8086 11.3086 17.2383 12.7383L15.7617 14.25C15.3398 13.8281 14.7539 13.4648 14.0039 13.1602C13.2773 12.8555 12.6094 12.7031 12 12.7031C11.3906 12.7031 10.7109 12.8555 9.96094 13.1602C9.23438 13.4648 8.66016 13.8281 8.23828 14.25L6.76172 12.7383ZM9.75 15.7617C10.3828 15.1289 11.1328 14.8125 12 14.8125C12.8672 14.8125 13.6172 15.1289 14.25 15.7617L12 18.0117L9.75 15.7617ZM3.73828 9.75C6.03516 7.47656 8.78906 6.33984 12 6.33984C15.2344 6.33984 17.9883 7.47656 20.2617 9.75L18.75 11.2617C16.875 9.41016 14.625 8.48438 12 8.48438C9.375 8.48438 7.125 9.41016 5.25 11.2617L3.73828 9.75Z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "wfo-clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
exports.WifiOn = WifiOn;